import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import thumb from "../../assets/img/landing/contact.svg"
import { saveContactUs } from "../../services/apiOtherlink";
import Validation from "../../commonComponents/Validation";
import ResponsePopup from "../../commonComponents/responseSucessPopup";
import "../../assets/css/style.css"
const ContactUs = (props) => {
 const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [comment, setComment] = useState('');
  const [error, setError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [isSucess, SetSucess] = useState(false);
  const [ResponseMessage, SetResponseMessage] = useState("");
  const saveContact = async () => {
      if (fullName !== "" && email !== "" && comment !== "") {
        setError(false)
        const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
        const result = pattern.test(email);
        if (result === false) {
          setEmailError(true)
        }
        else {
          setEmailError(false);
          const formData = {
            fullname: fullName,
            email: email,
            comment: comment
          }
          let contactSave = await saveContactUs(formData);
  
          if (contactSave.status) {
            setComment("");
             setFullName("");
             setEmail("");
              SetSucess(true);
              SetResponseMessage("The admin will review your suggestions and take the necessary steps");
          }
        }
  
      }
      else {
        setError(true);
  
      }
    }
    
    const closePopup = () => {
    props.closePop();
    setComment("");
    setFullName("");
    setEmail("");
     setError(false);
  };
      return (
    <div>
      <Modal dialogClassName="custom-modal modal-dialog-centered" show={props.openPop} onHide={closePopup}>
        <Modal.Header closeButton>
          <div className="popupheader">
            <div className="mod-bor-icon" >
              <img src={thumb} className="mod-icon black"></img>
            </div>
            <div className="header">
              <h4 className="modal-tittle">ContactUs</h4>

            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
<div className="edit-container contact-us">
        <div className="edit profile-wrapper w-100">
          <div className="edit-field">
            <label className="edit-profile-label w-25">Full name</label>
            <div className="edit-field-group">
              <div className="form-group">
                <input type="text"  className="form-control" 
                placeholder="Enter your Full name" style={{color:"black"}}
                  onChange={(e) => { setFullName(e.target.value) }} value={fullName} />
                {fullName === "" && error ? (
                  <Validation message={'Please enter your full name'} />
                ) : null}
              </div>
            </div>
          </div>

          <div className="edit-field">
            <label className="edit-profile-label w-25">Email Id</label>
            <div className="edit-field-group">
              <div className="form-group">
                <input type="text" placeholder="Enter your Email" className="form-control " 
                  onChange={(e) => { setEmail(e.target.value); setEmailError(false) }} value={email} />
                {email === "" && error ? (
                  <Validation message={'Please enter your email'} />
                ) : null}
                {email !== "" && emailError ? (
                  <Validation message={'Please enter valid email'} />
                ) : null}
              </div>
            </div>
          </div>

          <div className="edit-field">
            <label className="edit-profile-label w-25">Suggestion</label>
            <div className="edit-field-group">
              <div className="form-group">
                <textarea className="form-control " placeholder="Please enter your Suggestions"
                  onChange={(e) => { setComment(e.target.value) }} value={comment} />
                {comment === "" && error ? (
                  <Validation message={'Please enter your suggestions'} />
                ) : null}
              </div>
            </div>
          </div>


        </div>
      </div>
        

        </Modal.Body>
        <Modal.Footer className="full-w" >
          <button
            type="button"
            className="cancel-btn"
            onClick={() => {
              closePopup();
            }}
          >
            Cancel
          </button>

          <button className="next-btn" onClick={() => saveContact()}>
           Submit
          </button>
        </Modal.Footer>
      </Modal>
       {isSucess && (<ResponsePopup 
                      isSucess={isSucess} 
                      CancelPopup={() => { 
                       SetSucess(false);
                      }} 
                      message={ResponseMessage}
                    />)}
    </div>
  );
}
export default ContactUs;
